import { axios } from '../plugins/axios';

export default {
  namespaced: true,

  state: {
    tipoZoonosis: [],
  },

  getters: {
    getTipoZoonosis: (state) => state.tipoZoonosis,

    getListaZoonosis: (state) => {
      const listaZoonosis = [];
      state.tipoZoonosis.forEach((zoonosis) => {
        listaZoonosis.push({
          fk_idCatTipoZoonosis: zoonosis.id,
          fk_idHistoriaClinica: null,
          title: zoonosis.title,
          detalle: '',
        });
      });
      return listaZoonosis;
    },
  },

  mutations: {
    SET_TIPO_ZOONOSIS(state, tipoZoonosis) {
      state.tipoZoonosis = tipoZoonosis;
    },
  },

  actions: {
    async fetchTipoZoonosis({ commit }) {
      await axios
        .get('PoliciaCuadrantes/C3/catTipoZoonosis')
        .then((response) => {
          commit('SET_TIPO_ZOONOSIS', response.data.data);
        });
    },
  },
};
